<template>
    <div class="wh100">
        <el-table :data="rcvActRecList" border style="width: 100%" class="mt30">
            <el-table-column prop="ts" label="操作时间" align="center" width="220"></el-table-column>
            <el-table-column prop="action" label="动作" width="150" align="center"></el-table-column>
            <el-table-column prop="actRole" label="操作人身份" width="150" align="center"></el-table-column>
            <el-table-column prop="actorName" label="操作人" width="200" align="left"></el-table-column>
            <el-table-column prop="actDesc" label="附加信息" show-overflow-tooltip align="left"></el-table-column>
        </el-table>
    </div>
</template>


<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import comnApi from '../../api/comn'

    export default {
        name: 'swb-rcv-act-rec-list',
        desc: '收款操作记录',
        props: ['voucherId'],
        data: function () {
            return {
                rcvActRecList: []
            }
        },
        created: function () {
            this.getRcvActRecList();
        },
        methods: {
            getRcvActRecList: function () {
                let self = this;
                let postData = {
                    filterItems: {}
                };
                postData.filterItems.moduleName = "settle";
                postData.filterItems.sourceType = "rcv_voucher";
                postData.filterItems.sourceId = self.voucherId + '';
                comnApi.getXxxActRecsByFilter(postData, function (result) {
                    if(result.type === "info") {
                        self.rcvActRecList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payment/RcvActRecList.vue